import React, { CSSProperties, ReactNode } from 'react';
import { Text } from 'library';

export default function Callout({
    style = {},
    children,
}: {
    style?: CSSProperties;
    children?: ReactNode | ReactNode[];
}) {
    return (
        <Text
            textStyle={{
                marginBottom: 20,
                ...style,
            }}
            variant="h2"
        >
            {children}
        </Text>
    );
}
